import axios from 'axios'

const state = {
    project: {},
    projects: {},
    project_errors: {},
    project_loading: false,
}

const getters = {
    project: state => state.project,
    projects: state => state.projects,
    project_errors: state => state.project_errors,
    project_loading: state => state.project_loading,
}

const mutations = {
    setProject(state, project) {
        state.project = project
    },
    setProjects(state, projects) {
        state.projects = projects
    },
    setProjectErrors(state, project_errors) {
        state.project_errors = project_errors
    },
    setProjectLoading(state, project_loading) {
        state.project_loading = project_loading
    },
}

const actions = {
    async storeProject({commit}, data) {
        commit('setProjectLoading', true)
        commit('setProjectErrors', {})
        try {
            let response = await axios.post(`/api/projects/store`, data)
            commit('setProjectLoading', false)
            commit('setProjectErrors', {})
            return response.data.ok
        } catch (error) {
            console.log(error);
            commit('setProjectLoading', false)
            commit('setProjectErrors', error.response.data.errors)
            return false
        }
    },
    async getProjects({commit}, data) {
        try {
            let response = await axios.get(`/api/admin/projects`, data)
            commit('setProjects', response.data)
            return response.data.ok
        } catch (error) {
            console.log(error);
                return false
        }
    },
    async checkProjectDeletable({commit}, id) {
        commit('setProjectLoading', true)
        try {
            let response = await axios.get(`/api/projects/${id}/check-deletable`)
            commit('setProjectLoading', false)
            return response.data.ok
        } catch (error) {
            console.log(error);
            return false
        }
    },
    async destroyProject({commit}, id) {
        commit('setProjectLoading', true)
        try {
            let response = await axios.delete(`/api/projects/${id}/destroy`)
            commit('setProjectLoading', false)
            return response.data.ok
        } catch (error) {
            console.log(error);
            return false
        }
    },
    async selectProject({commit}, id) {
        commit('setProjectLoading', true)
        try {
            let response = await axios.post(`/api/projects/${id}/select`)
            commit('setProjectLoading', false)
            return response.data.ok
        } catch (error) {
            console.log(error);
            return false
        }
    },
    async updateProject({commit}, data) {
        commit('setProjectLoading', true)
        commit('setProjectErrors', {})
        try {
            let response = await axios.put(`/api/projects/${data.id}/update`, data)
            commit('setProjectLoading', false)
            commit('setProjectErrors', {})
            return response.data
        } catch (error) {
            console.log(error);
            commit('setProjectLoading', false)
            commit('setProjectErrors', error.response.data.errors)
            return false
        }
    },
}

export default {
    state,
    getters,
    mutations,
    actions
}